import { LOGIN, LOGOUT } from "./Constants"

export const login = (dispatch, params) => {
  dispatch({ 
		type: LOGIN, 
		payload: { 
			email: 		params.email, 
			password: params.password 
		} 
	})
}
export const logout = dispatch => dispatch({ type: LOGOUT })